<template>
    <div class="page flex-col">
        <div class="main flex-col">
            <img class="title_shadow" referrerpolicy="no-referrer"
                src="../assets/img/MasterDDSSlicePNG06747c9279f5e4f8fc81c80a08134a36.png" />
            <span class="footer">广西壮族自治区气象培训中心</span>
            <div class="button-wrappe flex-col">
                <div class="btn-back flex-row justify-between" @click="$router.push('/')">
                    <img class="img-back" referrerpolicy="no-referrer"
                        src="../assets/img/MasterDDSSlicePNGc10f7b98a802e59b37af721c7a06e583.png" />
                    <span class="text-back">返回</span>
                </div>
                <div class="image-wrapper flex-row justify-between">
                    <img class="img-gjz" referrerpolicy="no-referrer" @click="$router.push('/tourgjz')"
                        src="../assets/img/MasterDDSSlicePNGbaaa2d51c040276bb2c0511eb5d961a9.png" />
                    <img class="img-cawsmart" referrerpolicy="no-referrer" @click="$router.push('/tourcawsmart')"
                        src="../assets/img/MasterDDSSlicePNGa5359eac672e57b34ba3bd8ede0ce19f.png" />
                </div>
            </div>
            <img class="image_4" referrerpolicy="no-referrer"
                src="../assets/img/MasterDDSSlicePNG869b466c5ae26e3ba572b8aeb5208574.png" />
        </div>
    </div>
</template>
<script>
export default {
    data() {
        return {
            constants: {}
        };
    },
    methods: {}
};
</script>
  <style scoped lang="css" src="../assets/index.rem-TourScene.css" />